import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SupportTicketPayload {
    files?: File | File[];
    incidentRequest?: unknown;
    firstName?: string;
    lastName?: string;
    email?: string;
    requestSomeoneElse?: boolean;
    affectedEmail?: string;
    topic?: string;
    category?: string;
    payloadJson?: unknown;
    [key: string]: unknown;
}

export interface SupportTicketResponse {
    ticketId: string;
}

@Injectable({ providedIn: 'root' })
export class SupportApiService {
    private http = inject(HttpClient);

    private supportUrl = './backend/serviceNow/incident';

    submitTicket(payload: SupportTicketPayload): Observable<SupportTicketResponse> {
        const formData = new FormData();

        const payloadJson =
            payload.payloadJson ??
            (payload.incidentRequest ? { incidentRequest: payload.incidentRequest } : undefined);

        if (payloadJson !== undefined && payloadJson !== null) {
            formData.append('payloadJson', JSON.stringify(payloadJson));
        }

        if (payload.files instanceof File) {
            formData.append('files', payload.files);
        } else if (Array.isArray(payload.files)) {
            payload.files
                .filter((item): item is File => item instanceof File)
                .forEach((file) => formData.append('files', file));
        }

        return this.http.post<SupportTicketResponse>(this.supportUrl, formData);
    }
}
